import { render, staticRenderFns } from "./redesign.vue?vue&type=template&id=ffb24bee&lang=pug"
import script from "./redesign.vue?vue&type=script&lang=js"
export * from "./redesign.vue?vue&type=script&lang=js"
import style0 from "./redesign.vue?vue&type=style&index=0&id=ffb24bee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports